import type { AIMessage } from 'pkg/api/models/ai_message';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Record } from 'pkg/api/models/record';

export enum AIConversationType {
	General = 'general',
	SessionCreator = 'session_creator',
}

export interface AIConversation extends Record, AllowedActionable {
	organizationId: number;
	userId: number;
	title: string;
	type: AIConversationType;
	createdAt: number;
	updatedAt: number;
	conversationFull: boolean;

	messages?: AIMessage[];
}
